import React from 'react';
// import { components } from 'react-select';
import Loader from '../../../general/Loader';
import defaultTheme from '../../../../utils/styles/defaultTheme';
import styles from './../styles';

const newStyles = styles(defaultTheme);

const LoadingIndicator = (props) => {
    let className = `${props.className} hoi-poi-select__loading-indicator`;
    return (
        <div className={className} style={newStyles.loadingIndicator}>
            <Loader color="actionMinor" size="tiny" />
        </div>
    );
};

LoadingIndicator.displayName = 'LoadingIndicator';

export default LoadingIndicator;
